<template>
    <div class="container-fluid">
        <div class="col table-responsive" v-if="transactionPublic.length > 0">
            <table class="table table-bs is-bordered is-narrow is-hoverable">
                <thead>
                <tr>
                    <th scope="col">Bil</th>
                    <th scope="col">Maklumat Wakaf</th>
                    <th scope="col" style="width: 10px;">Sunting/Padam</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in transactionPublic" :key="item.projekWakaf">
                    <td><span class="fs-6 align-middle">{{ index + 1 }}</span></td>
                    <td>
                        <div class="d-flex flex-wrap">
                            <div class="d-flex flex-column me-3">
                                <span class="fs-6">Jenis wakaf:</span>
                                <span class="fw-bold">{{
                                        data.wakaf_type[data.wakaf_type.map(a => a.id).indexOf(transactionPublic[index].jenisWakaf)].Nama
                                    }}</span>
                            </div>
                            <div class="d-flex flex-column me-3">
                                <span class="fs-6">Daerah wakaf:</span>
                                <span class="fw-bold">{{
                                        data.wakaf_district[data.wakaf_district.map(a => a.KodDaerah).indexOf(transactionPublic[index].daerahWakaf)].daerah
                                    }}</span>
                            </div>
                            <div v-if="transactionPublic[index].jenisWakaf === 2" class="d-flex flex-column me-3">
                                <span class="fs-6">Projek wakaf:</span>
                                <span class="fw-bold" style="max-width: 300px;">{{
                                        data.wakaf_project[data.wakaf_project.map(a => a.kod).indexOf(transactionPublic[index].projekWakaf)].nama
                                    }}</span>
                            </div>
                            <div class="d-flex flex-column me-3">
                                <span class="fs-6">Bilangan:</span>
                                <span class="fw-bold">{{ transactionPublic[index].unit }} unit</span>
                            </div>
                            <div class="d-flex flex-column me-3">
                                <span class="fs-6">Nilai unit:</span>
                                <span class="fw-bold">{{ sumFormat(transactionPublic[index].jumlah) }}</span>
                            </div>
                            <div class="d-flex flex-column me-3">
                                <span class="fs-6">Berwakaf bagi:</span>
                                <span v-if="transactionPublic[index].jenisPemilik === 'Sendiri'" class="fw-bold">Diri sendiri</span>
                                <span v-if="transactionPublic[index].jenisPemilik === 'Mewakili Orang'" class="fs-6">Wakil kepada <span class="fw-bold">{{
                                        transactionPublic[index].namaPemilik
                                    }}</span></span>
                                <span v-if="transactionPublic[index].jenisPemilik === 'Mewakili Orang Meninggal'" class="fs-6" style="max-width: 300px;">Arwah  <span class="fw-bold">{{
                                        transactionPublic[index].namaPemilik
                                    }}</span></span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-primary" style="margin-right:10px;"
                                    @click="openEditModal(index)"><font-awesome-icon :icon="faPenToSquare" /></button>
                            <button type="button" class="btn btn-danger" @click="removeRow(index)">
                                <font-awesome-icon :icon="faTrash" /></button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <Modal ref="wakafModal">
        <template #Header>
            <div class="d-flex justify-content-between mb-2">
                <span class="fs-3">{{ modalForm.isUpdate? "Sunting":"Maklumat" }} transaksi wakaf</span>
                <button type="button" @click="wakafModal.closeModal" class="btn"><font-awesome-icon :icon="faXmark" /></button>
            </div>
        </template>
        <template #Body>
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <div class="mb-3">
                            <label class="form-label">Jenis wakaf</label>
                            <select class="form-select" :class="{'is-invalid': !modalForm.formError.jenisWakaf.valid}" @change="wakafDaerah(parseInt(($event.target as HTMLInputElement).value))"
                                    v-model="modalForm.jenisWakaf" required>
                                <option value="0" selected disabled>Sila pilih</option>
                                <option v-for="type in data.wakaf_type" :value="type.id">{{ type.Nama }}</option>
                            </select>
                            <div class="invalid-feedback" :class="{'is-invalid d-block': !modalForm.formError.jenisWakaf.valid}">
                                {{ modalForm.formError.jenisWakaf.message }}
                            </div>
                        </div>
                        <div v-if="!modalForm.isHiddenDistrict" class="mb-3">
                            <label class="form-label">Daerah wakaf</label>
                            <select class="form-select" v-model="modalForm.daerahWakaf" :disabled="modalForm.isHiddenDistrict" :class="{'is-invalid': !modalForm.formError.daerahWakaf.valid}"
                                    @change="daerahProjek(modalForm.jenisWakaf,parseInt(($event.target as HTMLInputElement).value))" required>
                                <option value="0" selected disabled>Pilih daerah</option>
                                <option v-for="daerah in modalForm.district_list" :value="daerah.KodDaerah">
                                    {{ daerah.daerah }}
                                </option>
                            </select>
                            <div class="invalid-feedback" :class="{'is-invalid d-block': !modalForm.formError.daerahWakaf.valid}">
                                {{ modalForm.formError.daerahWakaf.message }}
                            </div>
                        </div>
                        <div v-if="!modalForm.isHiddenProject" class="mb-3">
                            <label class="form-label">Projek wakaf</label>
                            <select class="form-select" :disabled="modalForm.isHiddenProject" :class="{'is-invalid': !modalForm.formError.projekWakaf.valid}"
                                    v-model="modalForm.projekWakaf"
                                    required>
                                <option value="0" selected disabled>Pilih projek</option>
                                <option v-for="project in modalForm.project_list" :value="project.kod">
                                    {{ project.nama }}
                                </option>
                            </select>
                            <div class="invalid-feedback" :class="{'is-invalid d-block': !modalForm.formError.projekWakaf.valid}">
                                {{ modalForm.formError.projekWakaf.message }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Bilangan unit</label>
                            <div class="w-100 d-flex justify-content-between">
                                <button type="button" class="btn btn-info"
                                        @click="incrementDecrement(false)"
                                ><font-awesome-icon :icon="faMinus" />
                                </button>
                                <input v-model="modalForm.unit" type="number" min="1" max="200000000" autocomplete="off"
                                       @input="typeValueUpdate( ($event.target as HTMLInputElement).value)"
                                       class="form-control d-inline text-center" :class="{'is-invalid': !modalForm.formError.unitWakaf.valid}"
                                       placeholder="Unit" required/>
                                <button class="btn btn-info"
                                        @click="incrementDecrement(true)"
                                        type="button"><font-awesome-icon :icon="faPlus" />
                                </button>
                            </div>
                            <div class="invalid-feedback" :class="{'is-invalid d-block': !modalForm.formError.unitWakaf.valid}">
                                {{ modalForm.formError.unitWakaf.message }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Bagi pihak</label>
                            <select v-model="modalForm.jenisPemilik" class="form-select" :class="{'is-invalid': !modalForm.formError.pihakWakaf.valid}"
                                    @change="setWakafOwnName($event)">
                                <option value="" selected disabled>Sila pilih</option>
                                <option v-for="jp in jenisPemilik" :value="jp">{{ jp }}</option>
                            </select>
                            <div class="invalid-feedback" :class="{'is-invalid d-block': !modalForm.formError.pihakWakaf.valid}">
                                {{ modalForm.formError.pihakWakaf.message }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Nama pemilik</label>
                            <input v-model="modalForm.namaPemilik" type="text" v-if="modalForm.jenisPemilik !== 'Sendiri'" :class="{'is-invalid': !modalForm.formError.namaPemilikWakaf.valid}"
                                   @input="updateParentName(($event.target as HTMLInputElement).value)" class="form-control" placeholder="Nama"/>
                            <div class="invalid-feedback" :class="{'is-invalid d-block': !modalForm.formError.namaPemilikWakaf.valid}">
                                {{ modalForm.formError.namaPemilikWakaf.message }}
                            </div>
                            <p  class="fs-6 name" v-if="modalForm.jenisPemilik === 'Sendiri'">{{(modalForm.namaPemilik.length > 0) ? modalForm.namaPemilik : "Sila masukkan nama di ruangan utama" }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #Footer>
            <div class="w-100 p-3 bg-warning mt-3 rounded">
                <div class="d-flex justify-content-between">
                    <span class="bg-success py-2 px-2 text-white rounded me-2" style="width: max-content">Jumlah: {{
                            sumFormat(modalForm.jumlah)
                        }}</span>
                    <button v-if="!modalForm.isUpdate" type="button" class="btn btn-primary" @click="addUpdateRow"><font-awesome-icon v-if="!modalForm.isUpdate" :icon="faPlus" class="me-1" /> Tambah</button>
                    <button v-if="modalForm.isUpdate" type="button" class="btn btn-primary" @click="addUpdateRow"><font-awesome-icon :icon="faRotate" class="me-1"  />Kemaskini</button>
                </div>
            </div>
        </template>
    </Modal>
    <button type="button" class="btn btn-primary position-fixed z-3" @click="openAddModal" style="bottom: 30%;right: 40px;"><font-awesome-icon :icon="faPlus" class="me-1" />Tambah</button>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import Swal from "sweetalert2"
import {sumFormat} from "@/utils/utils";
import type {FormGeneral} from "../interface/FormGeneral";
import Modal from "../../components/modal.vue";
import {faMinus, faPenToSquare, faPlus, faRotate, faTrash, faXmark} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";

library.add(faPlus, faMinus, faTrash, faXmark, faPenToSquare, faRotate);


const data = defineProps<{
    wakaf_type: [{
        id: number,
        Nama: string,
    }],
    wakaf_district: [{
        KodDaerah: number,
        WakafJenisID: number,
        daerah: string,
    }],
    wakaf_project: [{
        kod: number,
        nama: string,
        WakafJenisID: number,
        DaerahID: number,
    }],
    nama_pewakaf: string,
    userdata?: [{
        ID: number,
        JenisWakaf: number,
        KodDaerah: number,
        Projek: number,
        Unit: number,
        JenisPemilikan: string,
        NamaPemilik: string,
        Amaun: number,
        NoResitt: number,
        WakafResitID: number
    }],
    w_id?: number,
    d_id?: number,
    p_id?: number | string, // due to HBHD and gabby
}>();
const emitToExternal = defineEmits<{
    (e: "calulateSum", sum: number): void,
    (e: "updateName", name: string, ownerType: string): void,
}>()

const modalForm = ref<FormGeneral>({
    jenisWakaf: 0,
    daerahWakaf: 0,
    projekWakaf: 0,
    unit: 1,
    jumlah: 5,
    jenisPemilik: "",
    namaPemilik: "",
    district_list: [],
    project_list: [],
    isHiddenDistrict: true,
    isHiddenProject: true,
    isUpdate: false,
    editModalIndex: 0,
    formError:{
        jenisWakaf:{
            valid: true,
            message: "",
        },
        daerahWakaf:{
            valid: true,
            message: "",
        },
        projekWakaf:{
            valid: true,
            message: "",
        },
        unitWakaf:{
            valid: true,
            message: "",
        },
        pihakWakaf:{
            valid: true,
            message: "",
        },
        namaPemilikWakaf:{
            valid: true,
            message: "",
        },
    },
})
const transactionPublic = ref<FormGeneral[]>([]);
const wakafModal = ref<InstanceType<typeof Modal> | null>(null);
const jenisPemilik = ref<string[]>(["Sendiri", "Mewakili Orang", "Mewakili Orang Meninggal"])

const wakafDaerah = (jenisWakaf: number) : void => {
    modalForm.value.isHiddenDistrict = true;
    modalForm.value.isHiddenProject = true;
    modalForm.value.district_list = [];
    modalForm.value.project_list = [];
    modalForm.value.daerahWakaf = 0;
    modalForm.value.projekWakaf = 0;
    modalForm.value.formError.jenisWakaf.valid = true;
    modalForm.value.formError.jenisWakaf.message = "";

    switch (jenisWakaf){
        case 3: // Tabung wakaf masjid
            modalForm.value.daerahWakaf = 99;
            modalForm.value.projekWakaf = 3;
            break;
        case 4: // Tabung wakaf pendidikan
            modalForm.value.daerahWakaf = 99;
            modalForm.value.projekWakaf = 5;
            break;
        case 5: // Wakaf tunai
            modalForm.value.daerahWakaf = 99;
            modalForm.value.projekWakaf = 58;
            break;
        default:
            // Tabung wakaf umum
            if(jenisWakaf === 1){
                modalForm.value.projekWakaf = 26;
            }

            const districts: { KodDaerah: number, daerah: string }[] = getDaerahProjectIncluded();
            modalForm.value.district_list = districts;
            modalForm.value.isHiddenDistrict = false;
    }
}

const getDaerahProjectIncluded = () : { KodDaerah: number, daerah: string }[] =>{
    let filteredDistricts: { KodDaerah: number, daerah: string }[] = [];
    const uniqueDistrictIDs = new Set();
    for (let p = 0; p < data.wakaf_project.length; p++){
        if(![3,5,26].includes(data.wakaf_project[p].kod) && data.wakaf_project[p].WakafJenisID ===2){
            uniqueDistrictIDs.add(data.wakaf_project[p].DaerahID);
        }
    }
    for (let q = 0; q < data.wakaf_district.length; q++){
        if(uniqueDistrictIDs.has(data.wakaf_district[q].KodDaerah)){
            filteredDistricts.push({
                KodDaerah : data.wakaf_district[q].KodDaerah,
                daerah : data.wakaf_district[q].daerah
            });
        }
    }
    return filteredDistricts;
}
const daerahProjek = (jenisWakaf: number, daerah: number) : void => {
    modalForm.value.project_list = [];
    if(modalForm.value.jenisWakaf !== 1){
        modalForm.value.projekWakaf = 0;
    }
    modalForm.value.formError.daerahWakaf.valid = true;
    modalForm.value.formError.daerahWakaf.message = "";
    let filteredProjects: { kod: number, nama: string }[] = getProjectFiltered(jenisWakaf, daerah);
    if(filteredProjects.length > 0){
        modalForm.value.isHiddenProject = false;
        modalForm.value.project_list = filteredProjects;
    }
}
const getProjectFiltered = (jenisWakaf: number, daerah: number) : { kod: number, nama: string }[] =>{
    let filteredProjects: { kod: number, nama: string }[] = [];
    data.wakaf_project.forEach(function (item) {
        if (item["WakafJenisID"] === jenisWakaf && item["DaerahID"] === daerah) {
            filteredProjects.push({
                kod : item["kod"],
                nama : item["nama"]
            });
        }
    });
    return filteredProjects;
}
const incrementDecrement = (isIncrease: Boolean) : void => {
    if (isIncrease && modalForm.value.unit <= 200000000) {
        modalForm.value.unit++;
    } else if (!isIncrease && modalForm.value.unit > 1) {
        modalForm.value.unit--;
    }
    modalForm.value.jumlah = modalForm.value.unit * 5;
    calulcateAllSum();
};

const typeValueUpdate = (typedValue: string) : void => {
    if (typedValue.match(/[^a-zA-Z0-9 ]/) || parseInt(typedValue) < 1 || parseInt(typedValue) >= 200000000) {
        modalForm.value.unit = 1;
    }

    if (isNaN(parseInt(typedValue))) {
        modalForm.value.unit = 1;
    }
    modalForm.value.jumlah = modalForm.value.unit * 5;
    calulcateAllSum();
}

const setWakafOwnName = (event: Event) : void => {
    if(modalForm.value.namaPemilik === ""){
        modalForm.value.formError.namaPemilikWakaf.valid = true;
        modalForm.value.formError.namaPemilikWakaf.message = "";
    }
    const target = event.target as HTMLButtonElement;
    if (target.value === "Sendiri") {
        modalForm.value.namaPemilik = data.nama_pewakaf;
        transactionPublic.value.forEach(function (itemm: any, indexx: number) {
            if (transactionPublic.value[indexx].jenisPemilik === "Sendiri") {
                transactionPublic.value[indexx].namaPemilik = data.nama_pewakaf
            }
        })
    }
}

/* Literally the code below is not doing anything useful */
const updateParentName = (name: string) : void => {
    if (modalForm.value.jenisPemilik === "Sendiri") {
        transactionPublic.value.forEach(function (itemm: any, indexx : number) {
            if (transactionPublic.value[indexx].jenisPemilik === "Sendiri") {
                transactionPublic.value[indexx].namaPemilik = name
            }
        })
    }
    emitToExternal("updateName",modalForm.value.namaPemilik, modalForm.value.jenisPemilik);
}

const calulcateAllSum = () : void => {
    let sum: number = 0;
    transactionPublic.value.forEach(function (itemm: FormGeneral) {
        sum += itemm.jumlah;
    })
    emitToExternal("calulateSum", sum);

}

const openAddModal = () : void=> {
    if (transactionPublic.value.length === 0) {
        modalForm.value.jenisWakaf= 0;
        modalForm.value.daerahWakaf= 0;
        modalForm.value.projekWakaf= 0;
        modalForm.value.unit= 1;
        modalForm.value.jumlah= 5;
        modalForm.value.jenisPemilik= "";
        modalForm.value.namaPemilik= "";
        modalForm.value.district_list= [];
        modalForm.value.project_list= [];
        modalForm.value.isHiddenDistrict= true;
        modalForm.value.isHiddenProject= true;
        modalForm.value.isUpdate= false;
        wakafModal.value.showModal();
    } else if (transactionPublic.value.length > 0 && transactionPublic.value.length < 10){
        modalForm.value.jenisWakaf= transactionPublic.value[transactionPublic.value.length-1].jenisWakaf;
        modalForm.value.daerahWakaf= transactionPublic.value[transactionPublic.value.length-1].daerahWakaf;
        modalForm.value.projekWakaf= transactionPublic.value[transactionPublic.value.length-1].projekWakaf;
        modalForm.value.unit= 1;
        modalForm.value.jumlah= 5;
        modalForm.value.jenisPemilik= "";
        modalForm.value.namaPemilik= "";
        modalForm.value.isHiddenDistrict= false;
        if(transactionPublic.value[transactionPublic.value.length-1].jenisWakaf === 2){
            modalForm.value.district_list = getDaerahProjectIncluded();
            modalForm.value.project_list = getProjectFiltered(transactionPublic.value[transactionPublic.value.length-1].jenisWakaf, transactionPublic.value[transactionPublic.value.length-1].daerahWakaf)
            modalForm.value.isHiddenProject= false;
        }else{
            modalForm.value.district_list = data.wakaf_district;
            modalForm.value.project_list= [];
            modalForm.value.isHiddenProject= true;
        }
        modalForm.value.isUpdate= false;
        wakafModal.value.showModal();
    } else if (transactionPublic.value.length >= 10){
        Swal.fire({
            position: "center",
            icon: "info",
            title: "Hanya 10 transaksi dibenarkan bagi setiap pewakaf",
            timerProgressBar: true,
            timer: 3000
        })
    }
}
const openEditModal = (index: number) : void=> {
    modalForm.value.jenisWakaf= transactionPublic.value[index].jenisWakaf;
    modalForm.value.daerahWakaf= transactionPublic.value[index].daerahWakaf;
    modalForm.value.projekWakaf= transactionPublic.value[index].projekWakaf;
    modalForm.value.unit= transactionPublic.value[index].unit;
    modalForm.value.jumlah= transactionPublic.value[index].jumlah;
    modalForm.value.jenisPemilik= transactionPublic.value[index].jenisPemilik;
    modalForm.value.namaPemilik= transactionPublic.value[index].namaPemilik;
    modalForm.value.district_list= transactionPublic.value[index].district_list;
    modalForm.value.project_list= transactionPublic.value[index].project_list;
    modalForm.value.isHiddenDistrict= transactionPublic.value[index].isHiddenDistrict;
    modalForm.value.isHiddenProject= transactionPublic.value[index].isHiddenProject;
    modalForm.value.editModalIndex = index;
    modalForm.value.isUpdate= true;
    wakafModal.value.showModal();
}
const addUpdateRow = () : void => {
    if (transactionPublic.value.length < 10) {
        let formValidation: boolean = formValidate();
        // Check if validation is success and is going to add row
        if(formValidation && modalForm.value.isUpdate === false){
            transactionPublic.value.push({
                jenisWakaf: modalForm.value.jenisWakaf,
                daerahWakaf: modalForm.value.daerahWakaf,
                projekWakaf: modalForm.value.projekWakaf,
                unit: modalForm.value.unit,
                jumlah: modalForm.value.jumlah,
                jenisPemilik: modalForm.value.jenisPemilik,
                namaPemilik: modalForm.value.namaPemilik,
                district_list: modalForm.value.district_list,
                project_list: modalForm.value.project_list,
                isHiddenDistrict: modalForm.value.isHiddenDistrict,
                isHiddenProject: modalForm.value.isHiddenProject,
                isUpdate: modalForm.value.isUpdate,
                editModalIndex: modalForm.value.editModalIndex,
                formError:{
                    jenisWakaf:{
                        valid: true,
                        message: "",
                    },
                    daerahWakaf:{
                        valid: true,
                        message: "",
                    },
                    projekWakaf:{
                        valid: true,
                        message: "",
                    },
                    unitWakaf:{
                        valid: true,
                        message: "",
                    },
                    pihakWakaf:{
                        valid: true,
                        message: "",
                    },
                    namaPemilikWakaf:{
                        valid: true,
                        message: "",
                    },
                },
            });
            calulcateAllSum();
            wakafModal.value.closeModal();
        }
        if(formValidation && modalForm.value.isUpdate === true) {
            // Check if validation is success and is going to perform update
            transactionPublic.value[modalForm.value.editModalIndex].jenisWakaf = modalForm.value.jenisWakaf;
            transactionPublic.value[modalForm.value.editModalIndex].daerahWakaf = modalForm.value.daerahWakaf;
            transactionPublic.value[modalForm.value.editModalIndex].projekWakaf = modalForm.value.projekWakaf;
            transactionPublic.value[modalForm.value.editModalIndex].unit = modalForm.value.unit;
            transactionPublic.value[modalForm.value.editModalIndex].jumlah = modalForm.value.jumlah;
            transactionPublic.value[modalForm.value.editModalIndex].jumlah = modalForm.value.jumlah;
            transactionPublic.value[modalForm.value.editModalIndex].jenisPemilik = modalForm.value.jenisPemilik;
            transactionPublic.value[modalForm.value.editModalIndex].namaPemilik = modalForm.value.namaPemilik;
            transactionPublic.value[modalForm.value.editModalIndex].district_list = modalForm.value.district_list;
            transactionPublic.value[modalForm.value.editModalIndex].project_list = modalForm.value.project_list;
            transactionPublic.value[modalForm.value.editModalIndex].isHiddenDistrict = modalForm.value.isHiddenDistrict;
            transactionPublic.value[modalForm.value.editModalIndex].isHiddenProject = modalForm.value.isHiddenProject;
            transactionPublic.value[modalForm.value.editModalIndex].isUpdate = modalForm.value.isUpdate;
            transactionPublic.value[modalForm.value.editModalIndex].editModalIndex = transactionPublic.value.length;
            calulcateAllSum();
            wakafModal.value.closeModal();
        }
    }
}

const formValidate= () : boolean =>{
    let formValidation: boolean = true;
    modalForm.value.formError.jenisWakaf.valid = true;
    modalForm.value.formError.jenisWakaf.message = "";
    modalForm.value.formError.daerahWakaf.valid = true;
    modalForm.value.formError.daerahWakaf.message = "";
    modalForm.value.formError.projekWakaf.valid = true;
    modalForm.value.formError.projekWakaf.message = "";
    modalForm.value.formError.pihakWakaf.valid = true;
    modalForm.value.formError.pihakWakaf.message = "";
    modalForm.value.formError.namaPemilikWakaf.valid = true;
    modalForm.value.formError.namaPemilikWakaf.message = "";
    if(modalForm.value.jenisWakaf === 0){
        formValidation = false;
        modalForm.value.formError.jenisWakaf.valid = false;
        modalForm.value.formError.jenisWakaf.message = "Jenis wakaf tidak dipilih";
    }
    if(modalForm.value.daerahWakaf === 0){
        formValidation = false;
        modalForm.value.formError.daerahWakaf.valid = false;
        modalForm.value.formError.daerahWakaf.message = "Daerah wakaf tidak dipilih";
    }
    if(modalForm.value.jenisWakaf === 2 && modalForm.value.projekWakaf === 0){
        formValidation = false;
        modalForm.value.formError.projekWakaf.valid = false;
        modalForm.value.formError.projekWakaf.message = "Projek wakaf tidak dipilih";
    }
    if(modalForm.value.unit <= 0){
        formValidation = false;
        modalForm.value.formError.unitWakaf.valid = false;
        modalForm.value.formError.unitWakaf.message = "Daerah wakaf tidak dipilih";
    }
    if(modalForm.value.jenisPemilik === ""){
        formValidation = false;
        modalForm.value.formError.pihakWakaf.valid = false;
        modalForm.value.formError.pihakWakaf.message = "Jenis pewakaf tidak dipilih";
    }
    if(modalForm.value.namaPemilik === ""){
        formValidation = false;
        modalForm.value.formError.namaPemilikWakaf.valid = false;
        modalForm.value.formError.namaPemilikWakaf.message = "Nama pemilik tidak dipilih";
    }
    if(modalForm.value.namaPemilik === "" && modalForm.value.jenisPemilik === "Sendiri"){
        formValidation = false;
        modalForm.value.formError.namaPemilikWakaf.valid = true; // remarks
        modalForm.value.formError.namaPemilikWakaf.message = "";
    }
    return formValidation;
}

const removeRow = (index: number) : void=> {
    transactionPublic.value.splice(index, 1);
    calulcateAllSum();
}

onMounted(() => {
    if (data.w_id !== undefined && data.d_id !== undefined) {
        transactionPublic.value.push({
            jenisWakaf: data.w_id,
            daerahWakaf: data.d_id,
            projekWakaf: (data.p_id !== undefined)? (typeof data.p_id === "string")? 0 : data.p_id:0,
            unit: modalForm.value.unit,
            jumlah: modalForm.value.jumlah,
            jenisPemilik: "Sendiri",
            namaPemilik: modalForm.value.namaPemilik,
            district_list: getDaerahProjectIncluded(),
            project_list: getProjectFiltered(data.w_id,data.d_id),
            isHiddenDistrict: false,
            isHiddenProject: (data.p_id === undefined),
            isUpdate: modalForm.value.isUpdate,
            editModalIndex: modalForm.value.editModalIndex,
            formError:{
                jenisWakaf:{
                    valid: true,
                    message: "",
                },
                daerahWakaf:{
                    valid: true,
                    message: "",
                },
                projekWakaf:{
                    valid: true,
                    message: "",
                },
                unitWakaf:{
                    valid: true,
                    message: "",
                },
                pihakWakaf:{
                    valid: true,
                    message: "",
                },
                namaPemilikWakaf:{
                    valid: true,
                    message: "",
                },
            },
        });
    }
    if(data.userdata !== undefined){
        transactionPublic.value = [];
        for (let i = 0; i < data.userdata.length; i++){
            let unitt: number = 0;
            let jumlahh: number = 0;
            let projectCheck :{
                jenis: number,
                daerah: number,
                projek: number,
                isHiddenDistrict: boolean,
            } = {
                jenis: data.userdata[i].JenisWakaf,
                daerah: data.userdata[i].KodDaerah,
                projek: data.userdata[i].Projek,
                isHiddenDistrict: false,
            };

            if(data.userdata[i].Amaun < 5){
                unitt = 1;
                jumlahh = 5;
            } else{
                unitt = Math.ceil(data.userdata[i].Amaun/5);
                jumlahh = Math.ceil(data.userdata[i].Amaun/5) * 5;
            }

            let noMatchedProjectFlag: boolean = false;
            for(let j: number = 0; j < data.wakaf_project.length; j++){
                if (data.wakaf_project[j].kod === data.userdata[i].Projek){
                    noMatchedProjectFlag = true;
                    break;
                }
            }

            if(!noMatchedProjectFlag){
                projectCheck.jenis = 1;
                projectCheck.daerah = 1;
                projectCheck.projek = 26;
                projectCheck.isHiddenDistrict = false;
            }
            let shoulHiddenDistrict : boolean = false;
            let shoulHiddenProject : boolean = false;
            if(projectCheck.jenis === 1){
                shoulHiddenProject = true;
            }
            transactionPublic.value.push({
                jenisWakaf: projectCheck.jenis,
                daerahWakaf: projectCheck.daerah,
                projekWakaf: projectCheck.projek,
                unit: unitt,
                jumlah: jumlahh,
                jenisPemilik: data.userdata[i].JenisPemilikan,
                namaPemilik: data.userdata[i].NamaPemilik,
                district_list: getDaerahProjectIncluded(),
                project_list: getProjectFiltered(data.userdata[i].JenisWakaf, data.userdata[i].KodDaerah),
                isHiddenDistrict: shoulHiddenDistrict,
                isHiddenProject: shoulHiddenProject,
                isUpdate: modalForm.value.isUpdate,
                editModalIndex: i,
                formError:{
                    jenisWakaf:{
                        valid: true,
                        message: "",
                    },
                    daerahWakaf:{
                        valid: true,
                        message: "",
                    },
                    projekWakaf:{
                        valid: true,
                        message: "",
                    },
                    unitWakaf:{
                        valid: true,
                        message: "",
                    },
                    pihakWakaf:{
                        valid: true,
                        message: "",
                    },
                    namaPemilikWakaf:{
                        valid: true,
                        message: "",
                    },
                },
            });
        }
    }
    calulcateAllSum();
})

defineExpose({
    transactionPublic,
    openAddModal
})
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
